export type ThemePreference = 'light' | 'dark' | 'system';
const key = 'awarenow-theme';
let memoryPreference: ThemePreference | undefined;
export function preference(): ThemePreference {
  if (memoryPreference) return memoryPreference;
  try { const value = localStorage.getItem(key); return value === 'light' || value === 'dark' ? value : 'system'; } catch { return 'system'; }
}
export function applyTheme() {
  const value = preference();
  const dark = value === 'dark' || (value === 'system' && window.matchMedia?.('(prefers-color-scheme: dark)').matches);
  document.documentElement.dataset.theme = dark ? 'dark' : 'light';
}
export function subscribe(callback: () => void) {
  const update = () => { applyTheme(); callback(); };
  const media = window.matchMedia?.('(prefers-color-scheme: dark)');
  window.addEventListener('storage', update);
  window.addEventListener('awarenow-theme-change', update);
  media?.addEventListener('change', update);
  return () => { window.removeEventListener('storage', update); window.removeEventListener('awarenow-theme-change', update); media?.removeEventListener('change', update); };
}

export function setTheme(value: ThemePreference) {
  memoryPreference = value;
  try { localStorage.setItem(key, value); memoryPreference = undefined; } catch { /* Keep a session preference if storage is unavailable. */ }
  applyTheme(); window.dispatchEvent(new Event('awarenow-theme-change'));
}
